/**
 * Common
 *
 * Scripts for all pages.
 *
 * @since 1.0.0
 */

import $ from "jquery";

export default {
  init() {
    const hamburger = document.querySelector(".header__hamburger");

    hamburger?.addEventListener("click", toggleHamburger);

    function toggleHamburger() {
      hamburger?.classList.toggle("open");
      document.querySelector(".header__nav")?.classList.toggle("showClose");

      document
        .querySelector(".header__logo")
        ?.classList.toggle("original-logo-display");
      document
        .querySelector(".header__logo__hidden")
        ?.classList.toggle("logo-display");
    }

    // Hyphenate "Turvallisuuskulttuuri"
    const tabs = $('.featuredcategories__tab.__2 h2');
    console.log("tabs ", tabs);
    if (tabs.length) {
      tabs.each(function() {
        if (this.innerHTML.indexOf('Turvallisuuskulttuuri') !== -1) {
          this.innerHTML = '3. Turvallisuus&shy;kulttuuri';
        }
      })
    }

  },
  // JavaScript to be fired on all pages
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
